// The wait before poll number `pollCount` (0 for the first poll), or false
// once `maxPolls` polls have run. `jitter` spreads each wait by up to that
// fraction either way, so clients that started together don't poll together.
export const backoffDelay = (
  pollCount,
  { firstDelay, maxDelay, multiplier = 2, maxPolls = Infinity, jitter = 0 }
) => {
  if (pollCount >= maxPolls) return false

  const delay = Math.min(firstDelay * multiplier ** pollCount, maxDelay)
  return Math.round(delay * (1 + jitter * (2 * Math.random() - 1)))
}

const fetchCount = (query) =>
  query.state.dataUpdateCount + query.state.errorUpdateCount

// react-query options that poll while `shouldPoll(data, query)` is true, with
// the backoffDelay schedule. Spread them into the query's options. `data` is
// the query's own data, before any `select` and without `keepPreviousData`.
//
// The schedule starts over each time polling starts, so the first poll after
// new work (a payment, an import) waits `firstDelay` again. Failed fetches
// count toward `maxPolls`. A hidden page skips its polls, and coming back to
// the page checks at once, even after `maxPolls`.
export const backoffPolling = ({ shouldPoll, ...schedule }) => {
  const pollingSince = new WeakMap()

  return {
    refetchInterval: (_data, query) => {
      if (!shouldPoll(query.state.data, query)) {
        pollingSince.delete(query)
        return false
      }
      if (!pollingSince.has(query)) pollingSince.set(query, fetchCount(query))

      return backoffDelay(fetchCount(query) - pollingSince.get(query), schedule)
    },
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: (query) =>
      shouldPoll(query.state.data, query) ? "always" : false,
  }
}
